import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';

const BUTTON_HOST_ATTRIBUTES = [
  'vinnova-button-primary',
  'vinnova-button-secondary',
  'vinnova-button-remove',
  'vinnova-button-text',
  'vinnova-button-link',
  'vinnova-button-light',
];

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: `button[vinnova-button-primary], button[vinnova-button-secondary], button[vinnova-button-remove], button[vinnova-button-text], button[vinnova-button-link], button[vinnova-button-light]`,
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ButtonComponent implements OnInit {
  private _size: 'small' | 'medium' | 'large' | 'icon' | 'inline' = 'large';
  @Input() set size(value: 'small' | 'medium' | 'large' | 'icon' | 'inline') {
    this.elementRef.nativeElement.classList.remove(`size-${this.size}`);
    this._size = value;
    this.elementRef.nativeElement.classList.add(`size-${this.size}`);
  }
  get size() {
    return this._size;
  }

  constructor(public elementRef: ElementRef) {}

  ngOnInit() {
    this.elementRef.nativeElement.classList.add('vinnova-button');

    for (const attr of BUTTON_HOST_ATTRIBUTES) {
      if (this.hasHostAttributes(attr)) {
        this.elementRef.nativeElement.classList.add(attr);
        if (attr === 'vinnova-button-remove') {
          this.elementRef.nativeElement.classList.add('btn', 'btn-danger');
        }
      }
    }
  }

  hasHostAttributes(...attributes: string[]) {
    return attributes.some((attribute) =>
      this.elementRef.nativeElement.hasAttribute(attribute),
    );
  }

  @HostListener('blur')
  onBlur() {
    this.elementRef.nativeElement.classList.remove('focus-visible');
  }
}

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: `a[vinnova-button-primary], a[vinnova-button-secondary],
    a[vinnova-button-text]`,
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AnchorButtonComponent extends ButtonComponent {}
